import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39bd630a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mod_wrap mod_set_wrap select_none" }
const _hoisted_2 = { class: "mod_c_title watch_title" }
const _hoisted_3 = { style: {"margin-right":"20px"} }
const _hoisted_4 = { class: "mod_c_tbody" }
const _hoisted_5 = { class: "mod_content" }
const _hoisted_6 = { class: "mod_add" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font_size" }, "回放关闭时间：", -1))
const _hoisted_8 = { class: "mod_video" }
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "mod_bottom" }
const _hoisted_12 = {
  key: 0,
  class: "switch"
}
const _hoisted_13 = { class: "img" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { style: {"min-width":"720px"} }
const _hoisted_16 = { class: "mod_title" }
const _hoisted_17 = { class: "mod_duration" }
const _hoisted_18 = { class: "del-options" }
const _hoisted_19 = { class: "del" }
const _hoisted_20 = { class: "mod_save" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://images.innocomn.com/c3a4f202109221415107169.gif" }, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "listBox" }
const _hoisted_25 = { class: "listTop" }
const _hoisted_26 = { class: "top_left" }
const _hoisted_27 = { style: {"margin-left":"20px","width":"200px"} }
const _hoisted_28 = { style: {"color":"#00ccb0"} }
const _hoisted_29 = { class: "top_right" }
const _hoisted_30 = { class: "container_progress" }
const _hoisted_31 = {
  key: 0,
  style: {"height":"500px"}
}
const _hoisted_32 = {
  key: 1,
  style: {"height":"500px","text-align":"center","width":"100%","line-height":"400px"}
}
const _hoisted_33 = {
  key: 2,
  style: {"width":"100%","height":"480px","overflow-y":"auto"},
  "infinite-scroll-disabled": "false",
  "infinite-scroll-distance": "20"
}
const _hoisted_34 = { class: "listBottom" }
const _hoisted_35 = { class: "b_box" }
const _hoisted_36 = { class: "checkbox" }
const _hoisted_37 = ["onUpdate:modelValue", "onChange"]
const _hoisted_38 = { class: "b_left" }
const _hoisted_39 = ["src"]
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { class: "b_right" }
const _hoisted_42 = { class: "created_time" }
const _hoisted_43 = {
  class: "loading",
  style: {"height":"20px","line-height":"50px","text-align":"center"}
}
const _hoisted_44 = { key: 0 }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "您添加的视频包含打点内容，是否添加到自定义菜单中？", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "您添加的视频包含打点内容，自定义菜单数量已满，需要手动添加，是跳转到自定义菜单？", -1))

import { ref, computed, onUnmounted, nextTick, CSSProperties, onMounted } from 'vue';
import { Modal, Input, message, Progress, DatePicker } from 'ant-design-vue';
// import 'videojs-vr';
import 'video.js/dist/video-js.css';

// import videojs from 'tinymce/videojs-vr';
import 'videojs-vr/dist/videojs-vr.css';
import { getToken, getHelperStatus } from '@/plugins/cookie';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import http from '@/api/playback';
import moment from 'moment';
import Crumb from '@/components/Crumb.vue';
import SvgIcon from '@/components/SvgIcon.vue';
import CLoading from '@/components/CLoading.vue';
import CDelModal from '@/components/CDelModal.vue';
import { useDebounce } from '@/hooks/useDebounce'; //防抖
import { dragDrop } from '@/utils/format/dragDrop';
import { emptyDataSec } from '@/assets';
import { loadJs } from '@/utils/common';
import { VueDraggableNext } from 'vue-draggable-next';
import { SearchOutlined } from '@ant-design/icons-vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'playbackSettings',
  setup(__props) {

const aModal = Modal;
const aInputSearch = Input.Search;
const draggable = VueDraggableNext;
const aProgress = Progress;
const aDatePicker = DatePicker;

const route = useRoute();
const router = useRouter();
const disabled = ref(false);
const count_down = ref<any>(null);
const playList = ref<any>([]);
const addPlayList = ref<any>([]);
const videochecked = ref<any>([]); //选择视频放入数组
const coverImg = ref<boolean>(false);
const cycleSw = ref(false);
let switchstatus = ref<any>(false);
const shake = ref<boolean>(false);
const visible = ref<boolean>(false);
const delVisible = ref<boolean>(false);
const cusDotVisible = ref(false);
const toCusDot = ref(false);
const showLoading = ref<boolean>(false);
const uploading = ref(false);
let loadpage_total = ref<any>(0); //视频总条数
const last_page = ref(0); //最后一页数据
const loadpage_size = ref(1); //第几页数据
const noMore = ref(false); //判断是否有更多数据
const loading = ref(true);
const selectId = ref(0);
const percent = ref<any>(0);
const is_save_menu = ref(0);
const videoIndex = ref(0);
const videoKeyword = ref();
const videoRef = ref();
const delIndex = ref();
const videoPlayer = ref();
const token = getToken();
const store = useStore();
const videoWrapRef = ref();
const is_vr_status = ref();
const helperUrl = getHelperStatus();
const stateUrl = computed(() => store.state.home.customData.video_url);
const studioId = router.currentRoute.value.params.studioId;
onMounted(async () => {
  await loadJs('https://videojs-vr.netlify.app/dist/videojs-vr.js');
  await loadJs('https://videojs-vr.netlify.app/dist/videojs-vr.css');

});
onUnmounted(() => {
  if (videoPlayer.value) videoPlayer.value.dispose();
});

const player_data = ref({
  video_url: '',
  image_player_cover_url: '',
});
const dragOptions = ref({
  animation: 200,
  group: 'description',
  disabled: false,
  ghostClass: 'ghost',
});
const options = ref([
  {
    value: 0,
    label: '全部视频',
  },
  {
    value: 1,
    label: '打点视频',
  },
]);
const bodystyle: CSSProperties = {
  height: '580px',
  overflow: 'hidden',
  userSelect: 'none',
};
if (playList.value.length == 0) {
  coverImg.value = true;
} else {
  coverImg.value = false;
}
const addListVideo = () => {
  videochecked.value = [];
  addPlayList.value = [];
  loadpage_size.value = 1;
  visible.value = true;
  getCurrent(1, videoKeyword.value);
};
const videoSearch = () => {
  addPlayList.value = [];
  getCurrent(1, videoKeyword.value);
};
const disabledDate = (current: any) => {
  return current && current < moment().subtract(1, 'days'); //当天之前的不可选，不包括当天
};
const cycleSwitch = () => {
  http
    .cycleSwitch({ studio_id: studioId, cycle_switch: cycleSw.value ? '1' : '0', type: '2' })
    .then((res) => {
      message.success(res.data.message);
    })
    .catch((err) => {
      message.error(err.data.error);
    });
};
const moveEnd = () => {
  backSave(); //保存接口
};
const backSave = useDebounce(() => {
  let ids = ref<any>([]);
  playList.value.forEach((item: any) => {
    ids.value.push(item.id);
    player_data.value.video_url = item.video_url;
  });
  let data = {
    count_down: count_down.value,
    replay_ids: ids.value.join(','),
    status: switchstatus.value == true ? 1 : 0,
    studio_id: studioId,
    token: token,
    is_del: delIndex.value ? 1 : 0,
  };
  if (shake.value) {
    return;
  }
  shake.value = true;
  http
    .inset_video_replay(data)
    .then((res) => {
      shake.value = false;
      if (res.data.code == 200) {
        view_replay(1);
        message.destroy();
        message.success(res.data.message);
        delIndex.value = '';
        visible.value = false;
      }
    })
    .catch((res) => {
      message.destroy();
      message.error(res.data.error);
    });
});
//删除添加的视频
const toDelete = (index: number) => {
  delVisible.value = true;
  delIndex.value = index;
};
const handleOk = useDebounce((e: MouseEvent) => {
  let resData = addPlayList.value.filter((i: any) => videochecked.value.includes(i.id));
  let ids = ref<any>([]);
  resData.forEach((item: any) => {
    ids.value.push(item.id);
  });
  if (resData.length > 0) {
    let data = {
      count_down: count_down.value,
      replay_ids: ids.value.join(','),
      status: switchstatus.value == true ? 1 : 0,
      studio_id: studioId,
      is_del: delIndex.value ? 1 : 0,
    };
    http
      .inset_video_replay(data)
      .then(() => {
        visible.value = false;
        playList.value = resData;
        view_replay(2);
        http
          .isIncludeDot({ studio_id: studioId, video_ids: ids.value.join(',') })
          .then((res) => {
            if (res.data.data === 1) {
              cusDotVisible.value = true;
            } else if (res.data.data === 2) {
              toCusDot.value = true;
            }
          })
          .catch((err) => message.error(err.data.error));
      })
      .catch((err) => message.error(err.data.error));
  }
});
//获取视频列表
const getCurrent = (current: any, keywords: any) => {
  let data = {
    token: token,
    keywords: keywords,
    page: current,
    page_num: 10,
    dotting_status: selectId.value,
  };
  showLoading.value = true;
  http
    .getVideoList({ params: data })
    .then((res) => {
      showLoading.value = false;
      if (res.data.code == 200) {
        addPlayList.value.push(...res.data.data.data);
        addPlayList.value.forEach((i: any) => {
          if (videochecked.value.includes(i.id)) {
            i.check = true;
          } else {
            i.check = false;
          }
          return i;
        });
        loadpage_total.value = res.data.data.total;
        last_page.value = res.data.data.last_page;
      }
    })
    .catch((err) => {
      showLoading.value = false;
    });
};
//滚动加载数据
const getChildList = () => {
  if (loadpage_size.value >= last_page.value) {
    noMore.value = true;
  } else {
    noMore.value = false;
    loadpage_size.value++;
    getCurrent(loadpage_size.value, videoKeyword.value);
  }
};
const checkChange = (item: any) => {
  if (item.check) {
    videochecked.value.push(item.id);
  } else {
    const index = videochecked.value.indexOf(item.id);
    videochecked.value.splice(index, 1);
  }
};
//点击整个模块勾选
const checked = (e: any) => {
  e.currentTarget.previousElementSibling.firstElementChild.click();
};
const changeSelect = () => {
  addPlayList.value = [];
  getCurrent(1, videoKeyword.value);
};
const openDelModal = () => {
  delVisible.value = !delVisible.value;
  delIndex.value = '';
};
// 确定删除
const okDelModal = () => {
  playList.value.splice(delIndex.value, 1);
  delVisible.value = false;
  backSave();
};
const clickAddCustom = useDebounce((type: number) => {
  is_save_menu.value = type;
  http
    .is_save_dot_menu({ studio_id: studioId, is_save_menu: is_save_menu.value })
    .then((res) => {
      message.success(res.data.message);
      is_save_menu.value = 0;
    })
    .catch((err) => message.error(err.data.error));
  cusDotVisible.value = false;
});
const clickToCustom = (type: number) => {
  toCusDot.value = false;
  if (type) {
    router.push({ name: 'CustomizeMenu' });
  }
};

// 播放3d视频
const vOptions = {
  // poster: poster,//海报
  // playbackRates: [0.7, 1.0, 1.5, 2.0],//播放速度
  language: 'zh-CN',
  notSupportedMessage: '此视频暂时无法播放,请稍后再试',
  controls: true,
  techOrder: ['html5'], //html5模式和flvjs模式
  fluid: true, //流式布局,适应父元素大小
  preload: true, //预加载
  autoplay: true, //是否自动播放
  poster: player_data.value.image_player_cover_url,
};
const initVrPlayer = (data: any) => {
  videoPlayer.value = new window.videojs('videojs-player', vOptions);
  try {
    videoPlayer.value.src({
      src: data.video_url,
      // type: 'application/x-mpegURL',
    });
    videoPlayer.value.mediainfo = videoPlayer.value.mediainfo || {};
    videoPlayer.value.mediainfo.projection = '360';
    videoPlayer.value.vr({ projection: 'AUTO', debug: true, forceCardboard: false });
  } catch(err) {
    console.log(err);
  }
};


const changeEnden = () => {
  videoPlayer.value.on('ended', () => {
    videoIndex.value++;
    if (cycleSw.value && videoIndex.value > playList.value.length - 1) {
      videoIndex.value = 0;
    }
    if (
      playList.value[videoIndex.value].is_vr_video === 0 &&
      playList.value[videoIndex.value == 0 ? playList.value.length - 1 : videoIndex.value - 1].is_vr_video == 0
    ) {
      // 2d切2d
      Mplayer(playList.value[videoIndex.value]);
    } else {
      //3d切2d ，2d切3d ，3d切3d
      videoPlayer.value.dispose();
      videoWrapRef.value.innerHTML = `<video
          id="videojs-player"
          controls
          ref="videoRef"
          class="video-js vjs-matrix vjs-default-skin vjs-big-play-centered vjs-16-9"
        ></video>`;
      nextTick(() => {
        if (playList.value[videoIndex.value].is_vr_video == 0) {
          setTimeout(() => {
            Mplayer(playList.value[videoIndex.value]);
            changeEnden();
          });
        } else {
          setTimeout(() => {
            initVrPlayer(playList.value[videoIndex.value]);
            changeEnden();
          });
        }
      });
    }
  });
};
const view_replay = (type?: number) => {
  loading.value = true;
  disabled.value = true;
  let data = {
    token: token,
    studio_id: studioId,
  };
  http
    .get_studio_notice_replay_video({ params: data })
    .then((res) => {
      if (res.data.code == 200) {
        player_data.value.image_player_cover_url = res.data.data.image_player_cover_url; //封面图
        cycleSw.value = res.data.data.replay.cycle_switch ? true : false;
        if (res.data.data.replay.list && res.data.data.replay.list.length > 0) {
          playList.value = res.data.data.replay.list;
          player_data.value.video_url = res.data.data.replay.list[0].video_url;
          is_vr_status.value = res.data.data.replay.list[0].is_vr_video;
          res.data.data.replay.status == 1 ? (switchstatus.value = true) : (switchstatus.value = false);
          if (res.data.data.replay.count_down == '') {
            const aData = new Date();
            count_down.value = moment(aData);
          } else {
            count_down.value = moment(res.data.data.replay.count_down);
          }

          if (type === 1) {
            // 拖拽视频列表
            cutVrPlayer();
          } else if (type === 2) {
            // 添加视频列表
            if (!videoPlayer.value) {
              if (playList.value[videoIndex.value].is_vr_video == 0) {
                Mplayer(playList.value[0]);
                changeEnden();
              } else {
                initVrPlayer(playList.value[0]);
                changeEnden();
              }
            }
          } else {
            nextTick(() => {
              if (playList.value[videoIndex.value].is_vr_video == 0) {
                Mplayer(playList.value[0]);
                changeEnden();
              } else {
                initVrPlayer(playList.value[0]);
                changeEnden();
              }
            });
          }
        } else {
          // videoPlayer.value.dispose();
        }
      }
    })
    .finally(() => {
      loading.value = false;
      disabled.value = false;
    });
};
view_replay();


const cutVrPlayer = () => {
  
  // 拖拽视频列表判断第一个视频是2\3D
  videoIndex.value = 0;
  videoPlayer.value.dispose();
  videoWrapRef.value.innerHTML = `<video
          id="videojs-player"
          controls
          ref="videoRef"
          class="video-js vjs-matrix vjs-default-skin vjs-big-play-centered vjs-16-9"
        ></video>`;
        nextTick(() => {
    if (playList.value[0].is_vr_video == 0) {
      setTimeout(() => {
        Mplayer(playList.value[0]);
        changeEnden();
      });
    } else {
      setTimeout(() => {
        initVrPlayer(playList.value[0]);
        changeEnden();
      });
    }
  });
};
//m3u8格式
const Mplayer = (data: any) => {
  videoPlayer.value = new window.videojs('videojs-player', {
    language: 'zh-CN',
    notSupportedMessage: '此视频暂时无法播放,请稍后再试',
    controls: true,
    techOrder: ['html5'], //html5模式和flvjs模式
    fluid: true, //流式布局,适应父元素大小
    preload: true, //预加载
    autoplay: false, //是否自动播放
    poster: player_data.value.image_player_cover_url,
  });
  try {
    videoPlayer.value.src({
      src: data.video_url,
    });
    console.log(data.video_url,332232);
  } catch(err) {
    console.log(err,888);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Crumb),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(route).meta?.title), 1),
        _createVNode(_component_a_switch, {
          onChange: _cache[0] || (_cache[0] = ($event: any) => (playList.value.length > 0 ? _unref(backSave)() : '')),
          checked: _unref(switchstatus),
          "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => (_isRef(switchstatus) ? (switchstatus).value = $event : switchstatus = $event))
        }, null, 8, ["checked"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", null, [
              _hoisted_7,
              _createVNode(_unref(aDatePicker), {
                value: count_down.value,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((count_down).value = $event)),
                "show-time": { format: 'YYYY-MM-DD HH:mm' },
                placeholder: "选择日期时间",
                disabledDate: disabledDate
              }, null, 8, ["value"])
            ]),
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (addListVideo()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("添加视频")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("div", {
              ref_key: "videoWrapRef",
              ref: videoWrapRef
            }, [
              _createElementVNode("video", {
                ref_key: "videoRef",
                ref: videoRef,
                id: "videojs-player",
                controls: "",
                class: "video-js vjs-matrix vjs-default-skin vjs-big-play-centered vjs-16-9"
              }, null, 512)
            ], 512), [
              [_vShow, playList.value.length != 0]
            ]),
            (playList.value.length == 0 && player_data.value.image_player_cover_url != '')
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: player_data.value.image_player_cover_url
                }, null, 8, _hoisted_9))
              : _createCommentVNode("", true),
            (coverImg.value)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: _unref(stateUrl)
                }, null, 8, _hoisted_10))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_11, [
            (playList.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(SvgIcon, {
                    "icon-class": "loop_icon",
                    style: {"margin-right":"8px"}
                  }),
                  _createTextVNode("列表循环播放 "),
                  _createVNode(_component_a_switch, {
                    style: {"margin-left":"8px"},
                    onChange: cycleSwitch,
                    checked: cycleSw.value,
                    "onUpdate:checked": _cache[4] || (_cache[4] = ($event: any) => ((cycleSw).value = $event))
                  }, null, 8, ["checked"])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_unref(draggable), _mergeProps({ list: playList.value }, dragOptions.value, {
              onChange: moveEnd,
              handle: ".mover",
              options: { animation: 500 },
              onDrop: _unref(dragDrop)
            }), {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(playList.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "item-box",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("img", {
                        src: item.cover_url,
                        alt: ""
                      }, null, 8, _hoisted_14)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("p", _hoisted_16, _toDisplayString(item.title), 1),
                      _createElementVNode("p", _hoisted_17, _toDisplayString(item.duration), 1)
                    ]),
                    _createElementVNode("span", _hoisted_18, [
                      _createElementVNode("p", null, [
                        _createVNode(SvgIcon, {
                          class: "mover",
                          "icon-class": "drag_icon"
                        })
                      ]),
                      _withDirectives(_createElementVNode("p", _hoisted_19, [
                        _createVNode(SvgIcon, {
                          onClick: ($event: any) => (toDelete(index)),
                          "icon-class": "del",
                          style: {"color":"#505d6f"}
                        }, null, 8, ["onClick"])
                      ], 512), [
                        [_vShow, playList.value.length > 1]
                      ])
                    ])
                  ]))
                }), 128))
              ]),
              _: 1
            }, 16, ["list", "onDrop"])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(backSave)())),
              disabled: disabled.value
            }, {
              default: _withCtx(() => [
                _createTextVNode("保存")
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ])
      ]),
      _createVNode(_unref(aModal), {
        visible: visible.value,
        "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((visible).value = $event)),
        title: "添加视频",
        onOk: _unref(handleOk),
        width: "910px",
        "body-style": bodystyle
      }, {
        default: _withCtx(() => [
          false
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_a_select, {
                  value: selectId.value,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((selectId).value = $event)),
                  class: "polyglot_option",
                  options: options.value,
                  onChange: changeSelect
                }, null, 8, ["value", "options"]),
                _createVNode(_unref(aInputSearch), {
                  class: "mod_range_picker_search margin-b",
                  value: videoKeyword.value,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((videoKeyword).value = $event)),
                  placeholder: "请输入关键字",
                  onChange: _cache[8] || (_cache[8] = ($event: any) => (videoSearch()))
                }, {
                  enterButton: _withCtx(() => [
                    _createVNode(_unref(SearchOutlined))
                  ]),
                  _: 1
                }, 8, ["value"]),
                _createElementVNode("span", _hoisted_27, [
                  _createTextVNode("视频数量："),
                  _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(loadpage_total)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                (_unref(helperUrl))
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: { path: `/media/videos/${_unref(studioId)}` },
                      target: "_blank"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, null, {
                          default: _withCtx(() => [
                            _createTextVNode("去上传")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      to: { path: `/media` },
                      target: "_blank"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, null, {
                          default: _withCtx(() => [
                            _createTextVNode("去上传")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
              ])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_30, [
              _createVNode(_unref(aProgress), {
                percent: percent.value,
                status: "active",
                format: (percent) => `上传中：${percent}%`
              }, null, 8, ["percent", "format"])
            ], 512), [
              [_vShow, uploading.value]
            ]),
            (showLoading.value && addPlayList.value.length == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _createVNode(CLoading)
                ]))
              : (addPlayList.value.length == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    _createVNode(_component_a_empty, {
                      class: "empty_wrap",
                      image: _unref(emptyDataSec),
                      description: "页面暂无数据信息~"
                    }, null, 8, ["image"])
                  ]))
                : _createCommentVNode("", true),
            (addPlayList.value.length != 0)
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addPlayList.value, (i, j) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "item-box",
                        key: j
                      }, [
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("div", _hoisted_36, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": ($event: any) => ((i.check) = $event),
                              onChange: ($event: any) => (checkChange(i))
                            }, null, 40, _hoisted_37), [
                              [_vModelCheckbox, i.check]
                            ])
                          ]),
                          _createElementVNode("div", {
                            class: "b_content",
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (checked($event)))
                          }, [
                            _createElementVNode("div", _hoisted_38, [
                              _createElementVNode("img", {
                                src: i.cover_url
                              }, null, 8, _hoisted_39),
                              _createElementVNode("span", null, _toDisplayString(i.duration), 1),
                              (i.code == 207)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_40, "视频转码失败！"))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("h2", null, _toDisplayString(i.title), 1),
                              _createElementVNode("p", _hoisted_42, [
                                _createTextVNode(" 开始时间："),
                                _createElementVNode("span", null, _toDisplayString(i.created_at), 1)
                              ]),
                              _createElementVNode("p", null, "分辨率：" + _toDisplayString(i.resolution), 1)
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    (noMore.value && addPlayList.value.length > 9)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_44, "没有更多了"))
                      : _createCommentVNode("", true)
                  ])
                ])), [
                  [_directive_infinite_scroll, getChildList]
                ])
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["visible", "onOk"]),
      _createVNode(CDelModal, {
        visible: delVisible.value,
        centered: "",
        close: openDelModal,
        ok: okDelModal
      }, null, 8, ["visible"]),
      _createVNode(_unref(aModal), {
        visible: cusDotVisible.value,
        "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((cusDotVisible).value = $event)),
        title: "提示",
        centered: "",
        onOk: _cache[12] || (_cache[12] = ($event: any) => (_unref(clickAddCustom)(1))),
        onCancel: _cache[13] || (_cache[13] = ($event: any) => (_unref(clickAddCustom)(0)))
      }, {
        default: _withCtx(() => [
          _hoisted_45
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_unref(aModal), {
        visible: toCusDot.value,
        "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => ((toCusDot).value = $event)),
        title: "提示",
        centered: "",
        onOk: _cache[15] || (_cache[15] = ($event: any) => (clickToCustom(1))),
        onCancel: _cache[16] || (_cache[16] = ($event: any) => (clickToCustom(0)))
      }, {
        default: _withCtx(() => [
          _hoisted_46
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ], 64))
}
}

})